import { useState } from 'react'

import { tr } from 'mmfintech-commons'
import { useBanksRequest, useEventTracker, useFilteredBanks } from 'mmfintech-checkout-commons'

import SelectBank from '@components/SelectBank'
import { Input } from 'mmfintech-portal-commons'

import type { SupportedBank, UseAdditionalFieldsOutput } from 'mmfintech-checkout-commons/types'

interface SelectBankStepProps {
  sessionId: string
  countryCode: string
  fieldValues: UseAdditionalFieldsOutput
  onSubmit: () => void
}

export const SelectBankStep = (props: SelectBankStepProps) => {
  const { sessionId, countryCode, fieldValues, onSubmit } = props

  const [eventLogged, setEventLogged] = useState(false)

  const { trackEvent } = useEventTracker()

  const { banksCount, banksFetching } = useBanksRequest()
  const filteredBanks = useFilteredBanks((bank: SupportedBank) => handleSelectBank(bank ? bank.bankChoiceId : ''))

  const logBankSearchFocus = () => trackEvent(sessionId, 'bank_search_focus', undefined, true)
  const logBankSearchType = () => {
    if (!eventLogged) {
      void trackEvent(sessionId, 'bank_search_type', undefined, true)
      setEventLogged(true)
    }
  }

  const handleSelectBank = (bankCode: string) => {
    fieldValues.setValue('bankChoiceId', bankCode)
    void trackEvent(sessionId, 'bank_selected', bankCode)
  }

  return (
    <>
      {banksCount > 10 ? (
        <div className='search-container'>
          <Input
            key='bank-search'
            type='text'
            name='bank-search'
            maxLength={50}
            value={filteredBanks.bankSearchText}
            onChange={(_name: string, value: string) => {
              filteredBanks.setBankSearchText(value)
              logBankSearchType()
            }}
            onFocus={logBankSearchFocus}
            placeholder={
              countryCode === 'DEU'
                ? tr('CHECKOUT.PAYMENT.BANK_SEARCH_DEU', 'Start typing your bank name or BLZ')
                : tr('CHECKOUT.PAYMENT.BANK_SEARCH', 'Start typing your bank name')
            }
            hideErrorLine
            autoComplete='off'
            data-test='bank-search-input'
          />
        </div>
      ) : null}

      <SelectBank
        selected={fieldValues.getValue('bankChoiceId')}
        banks={filteredBanks}
        loading={banksFetching}
        handleSubmit={onSubmit}
      />
    </>
  )
}
